import { USER_TYPE_REFERRAL, USER_TYPE_RESELLER } from "./configs/constants";
import Forgot from "./pages/Auth/Forgot/Forgot";
import Login from "./pages/Auth/Login/Login";
import Register from "./pages/Auth/Register/Register";

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "SAR",
});

export const findPercentage = (discount, amount) => {
  return (discount / 100) * amount;
};

export const filterPagesByAddons = (ContentPages, authUser) => {
  if (authUser) {
    return ContentPages.filter((page) => {
      if (
        authUser.type === USER_TYPE_REFERRAL &&
        ["home", "companies", "companies_company"].includes(page.name)
      ) {
        return true;
      } else if (
        authUser.type === USER_TYPE_RESELLER &&
        [
          "home",
          "companies",
          "companies_company",
          "helpdesk",
          "profile",
          "commission",
          "payout_detail",
        ].includes(page.name)
      ) {
        return true;
      }
      return false;
    });
  } else {
    return [
      {
        path: "/login",
        name: "login",
        text: "login",
        component: Login,
        icon: false,
        showInSider: false,
      },
      {
        path: "/register",
        name: "register",
        text: "register",
        component: Register,
        icon: false,
        showInSider: false,
      },
      {
        path: "/forgot",
        name: "forgot",
        text: "forgot",
        component: Forgot,
        icon: false,
        showInSider: false,
      },
      {
        path: "*",
        name: "register",
        text: "register",
        component: Register,
        icon: false,
        showInSider: false,
      },
    ];
  }
};
